/* eslint-disable array-callback-return */
// 组通知卡片
import React, { useCallback, useEffect, useState, useContext, useMemo } from "react";
import { Card, message as toast } from "antd";
import "./index.less";
import { useTranslation } from "react-i18next";
import Context from "@/components/chat/context";
import {
  buildGroupMessageBody,
  FILE_DOWNLOAD_BIZTYPE,
  isBannedPostGroupSession
} from "@/utils/chat/message";
import { ChatMessage, ClientType, Employee, Session, SessionType } from "@/types/chat";
import { CalendarIcon } from "@/components/Calendars/Common";
import { getFileIconByMime, getFileUrl, downLoadFile as downLoadFileWeb } from "@/utils/chat/index";
import {
  buildJoyspaceIconUrl,
  buildPagePathKey
} from "@/components/Modals/JoyspaceFileSelectorModal/utils";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { RespondToNotificationReq, notificationAuthCode } from "@/api/notification";
import { connect } from "dva";
import ChatState from "@/types/chat/State";
import bus from "@/utils/bus";
import ImService from "@/server/ImService";
import IconFont from "@/components/icon";
import { ChatMessageExtType } from "@jd/jdee.im.sdk/lib/es/protocol/messageExtend/Type";
import colors from "@/components/styles/colors";
import { replaceGovUrl } from "@/utils/joyspace";
import DeeplinkEvent from "@/components/DeeplinkHandler/DeeplinkEvent";
import { isFocusEnv } from "@/utils";
import DownloadService from "@/server/DownloadService";
import { canJoyspacePreview, openJoyspacePreview } from "@/components/Joyspace/util";

interface MessageOperateProps {
  message: ChatMessage;
  selectedSession: Session;
  currentEmployee: Employee;
  sessionType: SessionType;
  sessionMessageMap: any;
  openNoticeDetails: (data: { isvisibles: boolean; notificationId: any }) => void;
}
type IProps = Readonly<MessageOperateProps>;
// let userInfo: any;
function GroupNotificationCard(props: IProps) {
  const {
    appRuntimeEnv: { joyspaceApiHost, joyspaceHost }
  } = useContext<GlobalContextConfig>(GlobalContext);
  const { selectedSession, message, currentEmployee, sessionMessageMap, openNoticeDetails } = props;
  let msg: any = message;
  const downloadServiceInstance = DownloadService.getInstance({});
  const { groupRosterIdentity, isSmall } = React.useContext(Context);
  const [notification, setNotification] = useState<any[]>([]);
  const imService = ImService.getInstance();
  const [t] = useTranslation("chat");
  const newDate = new Date().getTime();
  let newMsg = sessionMessageMap[selectedSession.sessionId];
  const GroupNotification = useCallback(async () => {
    // setVisible(true);
    openNoticeDetails({
      isvisibles: true,
      notificationId: msg.notificationId
    });
  }, [msg.notificationId, openNoticeDetails]);

  useEffect(() => {
    // 查询缓存
    const instance = ImService.getInstance();
    instance.getMessageExt(message.sessionId, message.mid).then((data) => {
      const msgContent = data?.msgContent || [];
      if (msgContent.length > 0) {
        setNotification(msgContent);
      }
    });
  }, [message]);

  const disabled = useMemo(() => {
    if (!notification || notification.length === 0) {
      return false;
    }
    let usersIdx = notification[0]?.users.findIndex((i: any) => {
      return i.pin === currentEmployee.userId;
    });
    if (usersIdx !== -1) {
      return true;
    } else {
      return false;
    }
  }, [currentEmployee, notification]);

  const received = useCallback(
    async (data?: any) => {
      if (disabled === true) return false;
      if (data?.content === message.content) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        msg = message;
      }
      newMsg?.map((item: any) => {
        if (item?.mid === data?.mid) {
          msg = item;
        }
      });
      let optionId: any;
      msg.optionList.map((item: any) => {
        // eslint-disable-next-line no-return-assign
        return (optionId = item.optionId);
      });
      let users = {
        app: currentEmployee.app,
        clientType: ClientType.PC,
        name: currentEmployee.name,
        nickName: currentEmployee.name,
        pin: currentEmployee.userId,
        teamId: currentEmployee.teamId,
        optionId: msg.optionList[0].optionId,
        timestamp: newDate
      };
      let msgContentItem = {
        users: [users]
      } as any;
      const msgType = ChatMessageExtType.GROUP_NOTICE;
      await RespondToNotificationReq({
        notificationId: msg.notificationId,
        optionId: optionId
      })
        .then(async (data) => {
          if (data[0] === null) {
            toast.error(data[1]);
            return false;
          } else {
            // setDisabled(true);
            const datas = buildGroupMessageBody({
              msgType,
              session: selectedSession,
              mid: msg.mid,
              msgContentItem
            });
            await imService.sendChatMessageExt(msg.sessionId, datas as any);
          }
        })
        .catch((err) => {
          toast.error(err);
          return;
        });
    },
    [currentEmployee, imService, message, msg, selectedSession, newDate]
  );

  useEffect(() => {
    bus.off("chat:message-groupnotificationcard", received);
    bus.on("chat:message-groupnotificationcard", received);
    return () => {
      bus.off("chat:message-groupnotificationcard", received);
    };
  }, [received]);

  const undateMessageExtListener = useCallback(() => {
    const instance = ImService.getInstance();
    instance.getMessageExt(message.sessionId, message.mid).then((data) => {
      const msgContent = data?.msgContent || [];
      if (msgContent.length > 0) {
        setNotification(msgContent);
      }
    });
  }, [message]);

  useEffect(() => {
    const instance = ImService.getInstance();
    const manager = instance.getChatManager();
    if (manager) {
      manager.on(
        `chat:message-groupnotificationcard:${message.sessionId}:${message.mid}`,
        undateMessageExtListener
      );
      return () => {
        manager.off(
          `chat:message-groupnotificationcard:${message.sessionId}:${message.mid}`,
          undateMessageExtListener
        );
      };
    }
  }, [message, undateMessageExtListener]);

  // 获取文件icon
  const getAttachmentIcon = (item: any) => {
    const { fileType, fileName } = item;
    if (fileType?.startsWith("joyspace")) {
      try {
        const strs = fileType.split("/");
        if (strs[1] === "6") {
          return getFileIconByMime(strs.slice(2).join("/") || "application/octet-stream")[0];
        } else {
          return buildJoyspaceIconUrl({
            title: fileName,
            pageType: strs[1],
            type: strs.slice(2).join("/") || "",
            apiHost: joyspaceApiHost
          });
        }
      } catch (error) {
        return getFileIconByMime(fileType || "application/octet-stream")[0];
      }
    }
    return getFileIconByMime(fileType || "application/octet-stream")[0];
  };

  // 文件下载
  async function downloadFile(item: any) {
    console.log("downloadFile-gtoup=>", item);
    if (item.fileType?.startsWith("joyspace")) {
      const path = buildPagePathKey(Number(item.fileType.split("/")[1])).subPath;
      let newUrl = `${joyspaceHost}/${path}/${item.fileId}`;
      let realUrl = replaceGovUrl(newUrl);
      return DeeplinkEvent.open(realUrl);
    }
    if (canJoyspacePreview(item?.fileName || "")) {
      const opt = {
        notificationId: item.notificationId || (message as any).notificationId,
        fileId: item.fileId || ""
      };
      const [res, err] = await notificationAuthCode(opt);
      if (err) {
        return toast.error(err);
      }
      openJoyspacePreview({
        code: res,
        host: joyspaceHost,
        isShowHeader: 1,
        canSaveToJoyspace: 1,
        canDownload: 1
      });
      return;
    }
    if (isFocusEnv()) {
      downloadServiceInstance.download(
        {
          viewFile: false,
          saveAs: true,
          message: {
            ...item,
            mid: item.fileId,
            id: item.fileId,
            url: item.fileUrl,
            notificationId: item.notificationId || (message as any).notificationId
          },
          auto: false,
          isGroup: false
        },
        {
          onStarted: () => {},
          onProgress: () => {},
          onCancel: () => {
            // console.log('onCancel ==>取消下载');
          },
          onPause: () => {
            // console.log('onPause ==> 暂停下载');
          },
          onResume: () => {
            // console.log('onResume ==> 恢复下载');
          },
          onFinish: () => {},
          onError: () => {}
        }
      );
    } else {
      // web 端下载文件
      const name = item.fileName;
      const url = getFileUrl(item.fileUrl, {
        bizType: FILE_DOWNLOAD_BIZTYPE.groupnotice,
        bizId: item.notificationId || (message as any).notificationId
      });
      downLoadFileWeb(name, url);
    }
  }

  return (
    <div className="GroupNotificationCard">
      <Card
        title={
          <div className="titleIcon">
            <div className="titleIcon_icon">
              <IconFont
                type="iconic_pc_notification_square"
                className="titleIcon-icon-small-icon"
              />
              <span style={{ fontSize: "14px", color: "#333333", fontWeight: 700 }}>
                {t("group_tz")}
              </span>
            </div>
            <div style={{ display: "flex", height: "24px", lineHeight: "23px" }}>
              <span style={{ width: "60px" }}>{message.nickName}</span>
              <span>{t("publish")}</span>
            </div>
          </div>
        }
        bordered={true}
        style={{ width: isSmall ? 273 : 301 }}
        // eslint-disable-next-line react/jsx-key
        actions={
          message.sender.userId === currentEmployee.userId
            ? []
            : [
                <div
                  className="ellipsi"
                  onClick={() => {
                    if (
                      isBannedPostGroupSession(selectedSession) &&
                      groupRosterIdentity === "ordinary"
                    ) {
                      return false;
                    }
                    received();
                  }}
                  key=""
                >
                  <button
                    className="btns"
                    disabled={disabled === false ? false : true}
                    style={{
                      cursor: disabled === true ? "not-allowed" : "pointer",
                      color: disabled === true ? "#BFC1C4" : `${colors.primary2}`
                    }}
                  >
                    {disabled === true ? "已回复" : "收到"}
                  </button>
                </div>
              ]
        }
      >
        <div
          onClick={() => {
            if (isBannedPostGroupSession(selectedSession) && groupRosterIdentity === "ordinary") {
              return false;
            }
            GroupNotification();
          }}
          style={{ cursor: "pointer" }}
        >
          <p className="mrl-11">{message.content}</p>

          {msg.attachmentList?.map((item: any, index: any) => {
            return (
              <div
                className="GroupNotificationCard-list mrl-11"
                key={index}
                onClick={(e) => {
                  e.stopPropagation();
                  downloadFile(item);
                }}
              >
                <div style={{ display: "flex" }}>
                  <span style={{ lineHeight: "26px" }}>
                    <CalendarIcon
                      // className="left"
                      src={getAttachmentIcon(item)}
                      width="12px"
                      height="12px"
                    />
                  </span>
                  <span
                    className="ellipsis"
                    style={{
                      marginLeft: "6px"
                    }}
                  >
                    {item.fileName}
                  </span>
                </div>
              </div>
            );
          })}

          {notification.length > 0 && (
            <div className="userList">
              <div style={{ display: "inline" }}>
                {notification[0]?.users?.map((item: any, index: any) => {
                  if (index > 5) return;
                  return (
                    <div key={index} style={{ display: "inline" }}>
                      <span>{item.name}</span>
                      {notification[0]?.users?.length === 1 ||
                      notification[0]?.users[notification[0]?.users?.length - 1] === item ||
                      index >= 5
                        ? ""
                        : "、"}
                    </div>
                  );
                })}
                <span>
                  {notification[0]?.users?.length > 5 && `等${notification[0]?.users?.length}人`}
                  已回复
                </span>
              </div>
            </div>
          )}
        </div>
      </Card>
    </div>
  );
}
function mapStateToProps({ chat }: { chat: ChatState }) {
  const { sessionMessageMap, selectedSession, currentEmployee } = chat;
  return {
    sessionMessageMap,
    selectedSession,
    currentEmployee
  };
}
function mapDispatchToProps(dispatch: any) {
  return {
    updateSessionMessageMid(data: { sendResult: any; sessionId: String }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    },
    pushChatMessage(data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    },
    openNoticeDetails(data: { isvisibles: boolean; notificationId: any }) {
      dispatch({ type: "chat/openNoticeDetails", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(GroupNotificationCard);
